---
nb:
  data_export:
    budget_revenue: Budsjettinntekt
    budget_volume: Budsjettvolum
    downtime_comment: Kommentarer om nedetid
    downtime_cost: Kostnad for nedetid
    downtime_reason: Årsak til nedetid
    downtime_volume: Nedetidsvolum
    from_date: Fra dato
    heading: Eksporter timesverdier til et regneark
    individual_power_plants: Velg enkeltkraftverk
    missing_exchange_rate_error: Valutakursdata mangler for den valgte perioden og valutaen. Vennligst kontakt support.
    pending_email: Regnearket blir sendt på e-post når det er klart.
    power_plants: Kraftverk
    price_areas: Velg alle kraftverk i prisområdet
    prices: Priser
    rate_limited: For mange forespørsler
    ready_notification:
      body: Klikk Vis for å laste ned regnearket.
      title: Dataeksporten din er klar
    report:
      budget_revenue:
        report_sheet_header: Inntekt
        report_sheet_name: Budsjettinntekt
        summary_sheet_header: Budsjettinntekt %{currency}
      budget_volume:
        report_sheet_header: MWh
        report_sheet_name: Budsjettvolum
        summary_sheet_header: Budsjettvolum MWh
      downtime_comment:
        report_sheet_header: Kommentarer
        report_sheet_name: Nedetidskommentarer
      downtime_cost:
        report_sheet_header: Kostnad
        report_sheet_name: Nedetidskostnad
        summary_sheet_header: Total nedetidskostnad %{currency}
      downtime_reason:
        report_sheet_header: Årsak
        report_sheet_name: Årsak til nedetid
      downtime_volume:
        report_sheet_header: MWh
        report_sheet_name: Nedetidsvolum
        summary_sheet_header: Totalt nedetidsvolum MWh
      monthly_sheet_left_header: Kraftverk
      monthly_sheet_sum_header: SUM
      monthly_sheet_title: Månedlig oppsummering
      monthly_sheet_top_header: Periode
      prices:
        report_sheet_header: Priser
        report_sheet_name: Priser
        summary_sheet_header: Priser (%{currency})
      report_sheet_left_headers:
      - Tidssone
      - Time
      revenue:
        report_sheet_header: Inntekter
        report_sheet_name: Inntekter
        summary_sheet_header: Bruttoinntekter %{currency}
      summary_sheet_left_header: Dataeksport
      summary_sheet_title: Sammendrag
      summary_sheet_top_header: Periode
      volume:
        report_sheet_header: MWh
        report_sheet_name: Volum
        summary_sheet_header: Produksjonsvolum MWh
    report_types: Rapporttyper
    revenue: Inntekt
    select_power_plants: Velg kraftverk
    to_date: Til dato
    volume: Volum
  errors:
    messages:
      export_too_large: Eksporten er for stor. Prøv et mindre datasett.
      no_power_plants_selected: Ingen kraftverk valgt
